/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComunicazioneOutboxStato } from './comunicazione-outbox-stato';
import { EventoTipoPratica } from './evento-tipo-pratica';
import { CanaleComunicazione } from './canale-comunicazione';


/**
 * Riga della coda comunicazioni (vista SUPERADMIN, senza dati anagrafici)
 */
export interface ComunicazioneOutboxDTO { 
    id?: string;
    comune_slug?: string;
    comune_nome?: string;
    tipo_pratica_id?: string;
    bando_titolo?: string;
    codice_pratica?: string;
    evento?: EventoTipoPratica;
    canale?: CanaleComunicazione;
    stato?: ComunicazioneOutboxStato;
    tentativi?: number;
    ultimo_errore?: string;
    next_attempt_at?: string;
    created_at?: string;
    inviata_at?: string;
    chiusa_at?: string;
}



